var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultCorrect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90938 20.625C7.36009 20.625 6.05033 20.0899 4.98021 19.0198C3.91007 17.9497 3.375 16.6399 3.375 15.0906V8.90938C3.375 7.36009 3.91007 6.05033 4.98021 4.98021C6.05033 3.91007 7.36009 3.375 8.90938 3.375H15.0906C16.6399 3.375 17.9497 3.91007 19.0198 4.98021C20.0899 6.05033 20.625 7.36009 20.625 8.90938V15.0906C20.625 16.6399 20.0899 17.9497 19.0198 19.0198C17.9497 20.0899 16.6399 20.625 15.0906 20.625H8.90938ZM11.0177 15.7135L16.7677 9.96354L15.7375 8.93333L11.0177 13.6531L8.69375 11.3292L7.66354 12.3594L11.0177 15.7135ZM8.90938 19.1875H15.0906C16.2247 19.1875 17.191 18.7882 17.9896 17.9896C18.7882 17.191 19.1875 16.2247 19.1875 15.0906V8.90938C19.1875 7.77533 18.7882 6.80904 17.9896 6.01042C17.191 5.2118 16.2247 4.8125 15.0906 4.8125H8.90938C7.77533 4.8125 6.80904 5.2118 6.01042 6.01042C5.2118 6.80904 4.8125 7.77533 4.8125 8.90938V15.0906C4.8125 16.2247 5.2118 17.191 6.01042 17.9896C6.80904 18.7882 7.77533 19.1875 8.90938 19.1875Z",
    fill: "#10BB2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultCorrect);
export default __webpack_public_path__ + "static/media/result_correct.5b190ffea6c84c9c34f7fadfd41ef32e.svg";
export { ForwardRef as ReactComponent };